import { setAuthToken } from './api';

export const handleLogout = (message = '') => {
  // Clear the token from localStorage and API
  localStorage.removeItem("jwt_token");
  setAuthToken(null);
  
  // Construct the redirect URL with an optional message
  const loginPath = '/';
  const redirectUrl = message 
    ? `${loginPath}?message=${encodeURIComponent(message)}`
    : loginPath;
  
  // Use React Router's history if available, otherwise fallback to window.location
  if (window.history && window.history.pushState) {
    window.history.pushState({}, '', redirectUrl);
    window.location.reload();
  } else {
    window.location.href = redirectUrl;
  }
}; 